/**
 * Google Gemini AI Integration Module
 * Handles model definitions, deprecation alias remapping, and API key helpers.
 */

export const GEMINI_MODELS = [
  {
    id: "gemini-3.8-flash",
    name: "Gemini 3.8 Flash (⚡ Flagship Default)",
    category: "⚡ Direct Google Gemini Models",
    badge: "⚡ Flagship Flash",
    description: "Flagship SOTA Flash default for software engineering, autonomous agents, and sub-second generation.",
    isVision: true,
    speedSec: 4,
    score: 95
  },
  {
    id: "gemini-3.1-pro-preview",
    name: "Gemini 3.1 Pro Preview (🧠 Reasoning)",
    category: "⚡ Direct Google Gemini Models",
    badge: "🧠 Pro Reasoning",
    description: "Latest SOTA reasoning model for complex architectural trees, deep logic, and heavy context.",
    isVision: true,
    speedSec: 8,
    score: 98
  },
  {
    id: "gemini-3.7-flash",
    name: "Gemini 3.7 Flash (🚀 Multi-Step Speed)",
    category: "⚡ Direct Google Gemini Models",
    badge: "🚀 High-Speed",
    description: "High-speed model optimized for multi-step execution and instant auto-expansions.",
    isVision: true,
    speedSec: 5,
    score: 93
  },
  {
    id: "gemini-3.5-flash-lite",
    name: "Gemini 3.5 Flash Lite (⚡ Lowest Latency)",
    category: "⚡ Direct Google Gemini Models",
    badge: "⚡ Low Latency",
    description: "Ultra-fast, lowest latency model built for high-throughput generation.",
    isVision: true,
    speedSec: 3,
    score: 90
  },
  {
    id: "gemini-3.6-flash",
    name: "Gemini 3.6 Flash (👁️ Multimodal)",
    category: "⚡ Direct Google Gemini Models",
    badge: "👁️ Multimodal",
    description: "Balanced multimodal Flash model for general agentic and vision tasks.",
    isVision: true,
    speedSec: 6,
    score: 94
  }
];

export const MODEL_ALIASES = {
  "gemini-2.5-pro": "gemini-3.1-pro-preview",
  "gemini-2.5-flash": "gemini-3.8-flash",
  "gemini-2.0-flash": "gemini-3.8-flash",
  "gemini-1.5-pro": "gemini-3.1-pro-preview",
  "gemini-1.5-flash": "gemini-3.8-flash"
};

/**
 * Automatically remaps deprecated/legacy Gemini model IDs to active SOTA counterparts.
 * @param {string} modelId
 * @returns {string} Active model ID
 */
export function remapGeminiModel(modelId) {
  if (!modelId) return "gemini-3.8-flash";
  const cleanId = String(modelId).trim().toLowerCase();
  if (MODEL_ALIASES[cleanId]) {
    console.log(`[Gemini Remap] Remapping deprecated model '${cleanId}' ➔ '${MODEL_ALIASES[cleanId]}'`);
    return MODEL_ALIASES[cleanId];
  }
  return modelId;
}

/**
 * Retrieve saved Google Gemini API key from localStorage
 * @returns {string} API key or empty string
 */
export function getGeminiApiKey() {
  try {
    return localStorage.getItem("gemini_api_key") || "";
  } catch (e) {
    return "";
  }
}

/**
 * Save Google Gemini API key to localStorage
 * @param {string} key
 */
export function setGeminiApiKey(key) {
  try {
    if (key) {
      localStorage.setItem("gemini_api_key", key.trim());
    } else {
      localStorage.removeItem("gemini_api_key");
    }
  } catch (e) {}
}

export const GOOGLE_AI_STUDIO_URL = "https://aistudio.google.com/app/apikey";
